import Api from './Api';

const END_POINT = "informar";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}`, request);
  },
  async get_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}-list-paginated`, request);
},
  async getSaleByOrden(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get("sale/getByOrden", request);
  },
  async store(informar) {
    return await Api.post(`${END_POINT}`, informar);
  },
  async update(informar) {
    return await Api.patch(`${END_POINT}/${informar.id}`, informar);
  },
  async change_status(informar) {
    return await Api.patch(
      `${END_POINT}/${informar.id}/change-status`,
      informar
    );
  },
  async change_status_confirmado(informar) {
    return await Api.patch(
      `${END_POINT}/${informar.id}/change-status_confirmado`,
      informar
    );
  },
  async delete(informar) {
    return await Api.delete(`${END_POINT}/${informar.id}`, informar);
  },
  async generatePdf(id, office_id) {
    // window.open(
    //   `${process.env.VUE_APP_API_URL}${END_POINT}/imprimir-resultado/${id}/${office_id}`,
    //   "_blank"
    // );
    return await Api.get(`${END_POINT}/imprimir-resultado/${id}/${office_id}`);
  },
};
